import { PLACEMENT_QUESTIONS, type PlacementAnswers } from '@mio/shared';
import { useId } from 'react';

export type PartialAnswers = Partial<PlacementAnswers>;

/** Six single-choice questions as native radio groups: keyboard and screen-reader behaviour for free. */
export function PlacementQuestions({
  answers,
  onChange,
}: {
  answers: PartialAnswers;
  onChange: <K extends keyof PlacementAnswers>(id: K, value: PlacementAnswers[K]) => void;
}) {
  const id = useId();
  return (
    <div className="path-questions">
      {PLACEMENT_QUESTIONS.map((question) => (
        <fieldset key={question.id} className="path-question">
          <legend>{question.prompt}</legend>
          <div className="path-options">
            {question.options.map((option) => {
              const inputId = `${id}-${question.id}-${option.value}`;
              const checked = answers[question.id] === option.value;
              return (
                <label
                  key={option.value}
                  htmlFor={inputId}
                  className="path-option"
                  data-checked={checked}
                >
                  <input
                    id={inputId}
                    type="radio"
                    name={`${id}-${question.id}`}
                    value={option.value}
                    checked={checked}
                    onChange={() => onChange(question.id, option.value)}
                  />
                  <span>{option.label}</span>
                </label>
              );
            })}
          </div>
        </fieldset>
      ))}
    </div>
  );
}
